module.exports = __webpack_public_path__ + "img/tencent.e77f07d7.png";